// The Settings page's frame: one tab strip over whichever section is open.
//
// Round 30. The sections themselves are unchanged pages, each keeping its own
// heading, its own route and its own guard — this component is navigation
// only, the same pill strip the Submissions page uses, rendered from
// SETTINGS_SECTIONS so the tabs, the sidebar entry and the index redirect
// cannot disagree about what Settings holds.
//
// The tabs are role-filtered the way the sidebar is: rendered for the roles
// that may use them, never rendered-and-disabled. A hidden tab is not an
// access control — every route behind one keeps its AdminsOnly/ManagersOnly
// wrapper, and the server refuses each independently.
import { Navigate, NavLink, Outlet } from 'react-router-dom';
import { useSession } from '../session';
import { settingsSections, type Role } from './navConfig';

export function SettingsLayout() {
  const { user } = useSession();
  if (!user) return null;

  const sections = settingsSections(user.role as Role);

  return (
    <div>
      <nav className="mb-5 flex flex-wrap items-center gap-2" aria-label="Settings sections">
        {sections.map((section) => (
          <NavLink
            key={section.to}
            to={section.to}
            className={({ isActive }) => (isActive ? 'btn-primary btn-sm' : 'btn-secondary btn-sm')}
          >
            {section.label}
          </NavLink>
        ))}
      </nav>
      <Outlet />
    </div>
  );
}

/**
 * Where /app/settings itself lands: the first tab this role can see. An admin
 * gets Company details; a manager the competency codes; a field worker
 * Security, which is the whole of their Settings.
 */
export function SettingsIndexRedirect() {
  const { user } = useSession();
  if (!user) return null;

  const first = settingsSections(user.role as Role)[0];
  return <Navigate to={first!.to} replace />;
}
